export default {
  background: {
    default: "#f6f7fb",
  },

  text: {
    main: "#6b6f85",
    focus: "#2f2f2f",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#1a1a1a",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#700808",
    focus: "#5e0707",
  },

  secondary: {
    main: "#8a8fa3",
    focus: "#6f7488",
  },

  info: {
    main: "#700808", // aligned with brand
    focus: "#5e0707",
  },

  success: {
    main: "#4CAF50",
    focus: "#3fa043",
  },

  warning: {
    main: "#fb8c00",
    focus: "#f57c00",
  },

  error: {
    main: "#F44336",
    focus: "#d32f2f",
  },

  light: {
    main: "#f5f6fa",
    focus: "#eef0f6",
  },

  dark: {
    main: "#2f2f2f",
    focus: "#1c1c1c",
  },

  grey: {
    100: "#fafafa",
    200: "#f0f2f5",
    300: "#e1e4ea",
    400: "#cfd4dc",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#700808",
      state: "#3d0404",
    },

    secondary: {
      main: "#8a8fa3",
      state: "#5c6073",
    },

    info: {
      main: "#700808",
      state: "#3d0404",
    },

    success: {
      main: "#66BB6A",
      state: "#2e7d32",
    },

    warning: {
      main: "#FFA726",
      state: "#EF6C00",
    },

    error: {
      main: "#EF5350",
      state: "#C62828",
    },

    light: {
      main: "#f7f8fc",
      state: "#e1e4ea",
    },

    dark: {
      main: "#2b2b2b",
      state: "#000000",
    },
  },

  coloredShadows: {
    primary: "rgba(112,8,8,0.45)",
    secondary: "rgba(138,143,163,0.35)",
    info: "rgba(112,8,8,0.35)",
    success: "rgba(76,175,80,0.35)",
    warning: "rgba(251,140,0,0.35)",
    error: "rgba(244,67,54,0.35)",
    light: "rgba(173,181,189,0.25)",
    dark: "rgba(0,0,0,0.5)",
  },

  inputBorderColor: "rgba(112,8,8,0.15)",

  tabs: {
    indicator: { boxShadow: "0 2px 6px rgba(112,8,8,0.4)" },
  },
};
